import { useMutation } from '@apollo/client';
import { HideEvent, HideEventVariables } from 'elitegrad-common/src/generated/HideEvent';
import HIDE_EVENT from 'elitegrad-common/src/queries/hideEvent.gql';

export const useEventStatusHiddenMutation = () => {
  const updateEventDisplayStatus = useMutation<HideEvent, HideEventVariables>(HIDE_EVENT);

  return updateEventDisplayStatus;
};
